import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tok-explore-modal',
  templateUrl: './tok-explore-modal.component.html',
})
export class TokExploreModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
